import { ds_AccordionLayoutBlock_Entry } from './layouts/AccordionLayoutBlock'
import { ds_ButtonGroupLayoutBlock_Entry } from './layouts/ButtonGroupLayoutBlock'
import { ds_EventsLayoutBlock_Entry } from './layouts/EventsLayoutBlock'
import { ds_ImageLayoutBlock_Entry } from './layouts/ImageLayoutBlock'
import { ds_LinksLayoutBlock_Entry } from './layouts/LinksLayoutBlock'
import { ds_NewsLayoutBlock_Entry } from './layouts/NewsLayoutBlock'
import { ds_QuoteLayoutBlock_Entry } from './layouts/QuoteLayoutBlock'
import { ds_RichTextLayoutBlock_Entry } from './layouts/RichTextLayoutBlock'
import { ds_SpacerLayoutBlock_Entry } from './layouts/SpacerLayoutBlock'
import { ds_TileLayoutBlock_Entry } from './layouts/TileLayoutBlock'
import { ds_VideoLayoutBlock_Entry } from './layouts/VideoLayoutBlock'


export const ds_LayoutBlock_Entry = `
    ${ds_AccordionLayoutBlock_Entry}
    ${ds_ButtonGroupLayoutBlock_Entry}
    ${ds_EventsLayoutBlock_Entry}
    ${ds_ImageLayoutBlock_Entry}
    ${ds_LinksLayoutBlock_Entry}
    ${ds_NewsLayoutBlock_Entry}
    ${ds_QuoteLayoutBlock_Entry}
    ${ds_RichTextLayoutBlock_Entry}
    ${ds_SpacerLayoutBlock_Entry}
    ${ds_TileLayoutBlock_Entry}
    ${ds_VideoLayoutBlock_Entry}

    fragment ds_LayoutBlock_Entry on ds_LayoutBlock_Entry {
        id
        canonicalUid

        layout_TopSpacing
        layout_SpaceBetween
        layout_ColorTheme
        layout_ColorPalette
        layout_ContainerWidth
        layout_FullWidthBackground

        layout_BackgroundElement {
            canonicalUid
            id
        }
        layout_contentBuilderLayout {
            grid
        }
        layout_contentBuilder {
            __typename

            ... on ds_AccordionLayoutBlock_Entry {
                id
                ...ds_AccordionLayoutBlock_Entry
            }

            ... on ds_ButtonGroupLayoutBlock_Entry {
                id
                ...ds_ButtonGroupLayoutBlock_Entry
            }

            ... on ds_EventsLayoutBlock_Entry {
                id
                ...ds_EventsLayoutBlock_Entry
            }

            ... on ds_ImageLayoutBlock_Entry {
                id
                ...ds_ImageLayoutBlock_Entry
            }

            ... on ds_LinksLayoutBlock_Entry {
                id
                ...ds_LinksLayoutBlock_Entry
            }

            ... on ds_NewsLayoutBlock_Entry {
                id
                ...ds_NewsLayoutBlock_Entry
            }

            ... on ds_QuoteLayoutBlock_Entry {
                id
                ...ds_QuoteLayoutBlock_Entry
            }

            ... on ds_RichTextLayoutBlock_Entry {
                id
                ...ds_RichTextLayoutBlock_Entry
            }

            ... on ds_SpacerLayoutBlock_Entry {
                id
                ...ds_SpacerLayoutBlock_Entry
            }

            ... on ds_TileLayoutBlock_Entry {
                id
                ...ds_TileLayoutBlock_Entry
            }

            ... on ds_VideoLayoutBlock_Entry {
                id
                ...ds_VideoLayoutBlock_Entry
            }
        }
    }
`
